import { useTranslation } from 'react-i18next'
import styles from './OurClients.module.css'
import {ReactComponent as PlusIcon} from 'assets/icons/plusIcon.svg'
import { Link } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { axiosConfig } from 'utils/axiosConfig'
import { useSelector } from 'react-redux'
import { Container } from 'react-bootstrap'
import AllClientsTable from 'components/Tables/AllClientsTable/AllClientsTable'
import ReactLoading from "react-loading";
import PaginationElement from 'components/Global/Elements/PaginationElement/PaginationElement'

function OurClients() {
  const {t} =useTranslation()

  const user =useSelector((state:any)=>state?.GlobalReducer?.user)
  const [itemsCount,setItemsCount]=useState('0')
  const [searchTerm,setSearchTerm]=useState('')
  const [items,setItems]=useState([])
  const [currentPage,setCurrentPage]=useState(1)
  const [pages,setPages]=useState(null)
  const [isLoading,setIsLoading]=useState(false)
  const [isPageLoading,setIsPageLoading]=useState(false)
  const [isDeleting,setIsDeleting] =useState<[Boolean]>([false])
  function getAllItems(){
    setIsPageLoading(true)
    axiosConfig.get(`/user/all-users?page=${currentPage}&name=${searchTerm}`,{
      headers: {
        "Authorization": `Bearer ${localStorage.getItem('token')}`,
      }
    }).then(res=>{
      setIsPageLoading(false)
      setItems(res.data?.data?.data)
      setPages(res.data?.data?.pages)
      let deletedNumber:any = [...Array(res.data.data.count)]
      setItemsCount(res.data.data.count)
      setIsDeleting(deletedNumber)
    }).catch(err=>{
      setIsPageLoading(false)
      console.log(err)
    })
  }
  function deleteItem(deltedId:String ,index:any){
    let modifiedDelete:[Boolean]=[...isDeleting]
      modifiedDelete[index]=true
    setIsDeleting(modifiedDelete)
      axiosConfig.delete(`/user/delete-user/${deltedId}`,{
        headers: {
            "Authorization": `Bearer ${localStorage.getItem('token')}`
        }
    }).then(res=>{
            let modifiedDelete:[Boolean]=[...isDeleting]
            modifiedDelete[index]=false
            setIsDeleting(modifiedDelete)
            toast.success(t('Item Deleted Successfully'))
            getAllItems()
      }).catch(err=>{
          let modifiedDelete:[Boolean]=[...isDeleting]
          modifiedDelete[index]=false
          setIsDeleting(modifiedDelete)
          toast.error(err?.response?.data?.message)
          console.log(err)
      })
  }
  useEffect(()=>{
    getAllItems()
  },[currentPage])

  const handlePageChange = (page:any) => {
    setItems([])
    setCurrentPage(page?.selected + 1);
  };

  return (
    <>
      <section className={styles['page-wrapper']}>
        <Container>
          <div className={styles['page-header']}>
            <div className={styles['page-header__top-wrapper']}>
              <h1 className={styles['page-header__title']}>
              {t('Our Clients')}
              <span className={styles['page-header__title-count']}>{itemsCount}</span>
              </h1>
              {
                user?.permission_type=='admin' &&
                  <Link to='add-client' className={styles['page-header__link']}>
                    {t('Add New Client')}
                    <PlusIcon/>
                  </Link>
              }
            </div>

            <div className={styles['page-header__search-inputs-wrapper']}>
              <input 
                type='text'
                className={styles['page-header__search-input']}
                placeholder={`${t("Enter the customer's name, phone number, and invoice number")}`}
                value={searchTerm}
                onChange={(e)=>setSearchTerm(e.target.value)}
              />
              {/* <input 
                type='date'
                className={styles['page-header__search-input']}
                // placeholder={`${t("Enter the customer's name, phone number, and invoice number")}`}
              /> */}
              <button 
                type='button' 
                className={styles['page-header__search-submit']}
                onClick={getAllItems} 
                disabled={isLoading}>
                {
                  !isLoading?
                  <>{t('Search')} </>
                  :<ReactLoading type={"spin"} color={'#5885C3'} height={30} width={30} />
                }
              </button> 
              {/* <button className={styles['page-header__search-submit']}>{t('Search')}</button> */}
            </div>
          </div>
        </Container>
        <AllClientsTable 
          items={items} 
          deleteItem={deleteItem} 
          isDeleting={isDeleting} 
          isPageLoading={isPageLoading}
          currentPage={currentPage}
          itemsCount={itemsCount}
        />
        <PaginationElement
          pageCount={Math.ceil(Number(itemsCount) / 10)}
          onPageChange={handlePageChange}
        />
      </section>
    </>
  )
}

export default OurClients